import { createSlice } from '@reduxjs/toolkit';
import { insertCareer } from './CareersThunks'; // Adjust this import according to your actual path

const initialState = {
  careers: [],
  loading: false,
  error: null,
  successMessage: '',
};

const careersSlice = createSlice({
  name: 'careers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(insertCareer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertCareer.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
        state.careers.push(action.payload.career);  // Add the newly created career entry
      })
      .addCase(insertCareer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'An error occurred';
      });
  },
});

export default careersSlice.reducer;
